import {GET_REASONS_TYPES} from "../../../enums/Request/request.types";

export const getAllReasonTypesAction = (reasons) => {
    return {
        type: GET_REASONS_TYPES,
        payload: reasons,
    };
};
